import { FC } from 'react';
import { Box, Skeleton, Paper } from '@mui/material';

interface MessageLoaderProps {
  numberOfMessages?: number;
}

export const MessageLoader: FC<MessageLoaderProps> = ({ numberOfMessages = 6 }) => {
  const messagePositions = [false, true, true, false, true, true];
  const messageSizes = [69, 41, 21, 52, 25, 38];
  const dateDividers = [0, 3];

  return (
    <Box
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        p: 2, 
        gap: 1,
        height: '100%',
        width: '100%',
        overflow: 'auto',
        backgroundColor: 'grey.100',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(0,0,0,0.1)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.3)',
          borderRadius: '2px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'rgba(0,0,0,0.5)',
        },
      }}
    >
      {messagePositions.map((isRight, index) => (
        <Box key={index} sx={{ width: '100%' }}>
          {dateDividers.includes(index) && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: index > 0 ? 2 : 0 }}>
              <Skeleton 
                variant="rectangular" 
                width={120} 
                height={24} 
                sx={{ borderRadius: 10 }} 
              />
            </Box>
          )}
          
          <Box
            sx={{
              display: 'flex',
              justifyContent: isRight ? 'flex-end' : 'flex-start',
              mb: 2,
              maxWidth: '100%',
            }}
          >
            <Box sx={{ 
              maxWidth: { xs: '85%', sm: '75%', md: '70%' },
              minWidth: '120px',
              width: `${messageSizes[index]}%` 
            }}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  bgcolor: isRight ? 'rgba(25, 118, 210, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                  borderRadius: 4,
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                }}
              >
                <Skeleton variant="text" width="100%" height={20} />
                {messageSizes[index] > 40 && (
                  <Skeleton variant="text" width="80%" height={20} />
                )}
                {messageSizes[index] > 60 && (
                  <Skeleton variant="text" width="60%" height={20} />
                )}
              </Paper>
              <Box sx={{ display: 'flex', justifyContent: isRight ? 'flex-end' : 'flex-start', mt: 0.5 }}>
                <Skeleton variant="text" width={60} height={16} />
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default MessageLoader;
